import client from '../httpClient';

const getUserSearchListApi = (params) => {
  return client.get('/division-masters/user-search-list', { params });
};

export default getUserSearchListApi;
